window.rwd || (window.rwd = {});

;(function($package, UIComponent, ScreenSize) {
    // TODO jakby dobrze jeszcze powyciągać selektory ze środka i zrobić metody odnajdujące określone zestawy składowych
    // to można by z tego Tabs zrobić podklasę Accordion

    $package.Tabs = Tabs;
    extendz(Tabs, UIComponent);
    function Tabs(node, name, options) {
        UIComponent.call(this, node);
        var that = this;
        this.node = node;
        this.name = name;
        var tabNo = TabsControl.getHashTabNo(name);
        this.options = $.extend({}, Tabs.defaults, options,
                tabNo == -1
                    ? {}
                    : {expanded: tabNo-1});
        this.init();
        $(this.node).addClass("tabs_off");
        if (this.options.onCondition()) {
            this.on();
        }
        HashControl.addHashChangeListener(function(hash) {
            that.onHashChange(hash);
        });
    }
    Tabs.ITEM_CLASS = "tabs_item";
    Tabs.ITEM_ACTIVE_CLASS = "tabs_item_active";
    Tabs.ITEM_INACTIVE_CLASS = "";
    Tabs.defaults = {
        onCondition: function() { return ScreenSize.is(ScreenSize.SIZES.MEDIUM) || ScreenSize.is(ScreenSize.SIZES.LARGE); },
        expanded: 0
    };

    Tabs.prototype.init = function() {
        if (this.initied) {
            return;
        }
        this.inited = true;
        var that = this;

        var $node = $(this.node);
        $node.find("> .tabs_items > .tabs_item").each(function(index) {
            if (index == that.options.expanded) {
                $(this).addClass(Tabs.ITEM_ACTIVE_CLASS);
            } else {
                $(this).addClass(Tabs.ITEM_INACTIVE_CLASS);
            }
            that.registerItemControlClick(index, this);
        });

        $(document).onPage(ScreenSize.SIZE_CHANGE_EVENT_NAME, function() {
            that.toggle();
        });
    };
    Tabs.prototype.registerItemControlClick = function(itemIndex, itemNode) {
        var that = this;
        $(this.node).find("> .tabs_menu > .tab_menuItem").eq(itemIndex).onPage("click", function() {
            if (!that.isOn()) {
                return;
            }
            that.onItemControlClick(itemIndex, itemNode);
        });
    };
    Tabs.prototype.onItemControlClick = function(itemIndex, itemNode) {
        TabsControl.setTab(this.name, itemIndex+1);
    };
    Tabs.prototype.onHashChange = function(hash) {
        var tabNo = TabsControl.getHashTabNo(this.name);
        if (tabNo === -1) {
        	// gdy nie ma info w hash to otwieramy domyślną zakładkę
        	tabNo = TabsControl.defaultTab[this.name];
        }
        var itemIndex = tabNo-1;
        this.updateView(itemIndex, $(this.node).find("> .tabs_items > .tabs_item").eq(itemIndex)[0]);
    };
    Tabs.prototype.updateView = function(itemIndex, itemNode) {
        var that = this;
        var $itemNode = $(itemNode);
        if (!$itemNode.hasClass(Tabs.ITEM_ACTIVE_CLASS)) {
            $(this.node).find("> .tabs_items > .tabs_item" + "."+Tabs.ITEM_ACTIVE_CLASS).each(function() {
                that.itemClose(this);
            });
            that.itemOpen($itemNode);
        }
        if (!$itemNode.hasClass($package.Accordion.ITEM_ACTIVE_CLASS)) {
            $itemNode.find('> .head > *').trigger("click");
        }
    };
    Tabs.prototype.itemOpen = function(itemNode, animated) {
        var $itemNode = $(itemNode);
        $itemNode.removeClass(Tabs.ITEM_INACTIVE_CLASS).addClass(Tabs.ITEM_ACTIVE_CLASS);
        if (this.isOn()) {
            $(this.node).find("> .tabs_menu > .tab_menuItem").eq($itemNode.index())
                .addClass("active")
                .attr('aria-selected', true)
                .attr('tabindex', "0");
            $itemNode.show();
            this.updateDescendants($itemNode);
        }
        $(window).trigger("Tabs:openActiveItem", [$itemNode, Tabs.ITEM_ACTIVE_CLASS]);
    };
    Tabs.prototype.itemClose = function(itemNode, animated) {
        var $itemNode = $(itemNode);
        $itemNode.removeClass(Tabs.ITEM_ACTIVE_CLASS).addClass(Tabs.ITEM_INACTIVE_CLASS);
        if (this.isOn()) {
            $itemNode.hide();
            $(this.node).find("> .tabs_menu > .tab_menuItem").eq($itemNode.index()).removeClass("active");
        }
    };
    Tabs.prototype.isOn = function() {
        return $(this.node).hasClass("tabs_on");
    };
    Tabs.prototype.on = function() {
        var $node = $(this.node).removeClass("tabs_off").addClass("tabs_on");
        $node.find("> .tabs_items > .tabs_item").hide();
        this.itemOpen($node.find("> .tabs_items > .tabs_item" + "."+Tabs.ITEM_ACTIVE_CLASS)[0]);
    };
    Tabs.prototype.off = function() {
        var $node = $(this.node).removeClass("tabs_on").addClass("tabs_off");
        $node.find("> .tabs_items > .tabs_item").show();
        $node.find("> .tabs_menu > .tab_menuItem").removeClass("active");
    };
    Tabs.prototype.toggle = function() {
        if (this.options.onCondition()) {
            this.on();
        } else {
            this.off();
        }
    };
    Tabs.prototype.closestDescendants = function(searchRoot) {
        var compareNode = this.node;
        var selector = "."+UIComponent.COMMON_CLASS_NAME;
        var result = $(searchRoot).find(selector).filter(function() {
            var parents = $(this).parents(selector);
            if (parents[0] == compareNode) {
                return true;
            }
            return (parents.first().is(".accordion") && parents.first().parents(selector)[0] == compareNode);
        });
        return result;
    };

})(rwd, rwd.UIComponent, rwd.ScreenSize);
